var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 16,
    fill: "#54ba4c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 36.0209C9.86375 36.0209 2.03125 28.3892 2.03125 19.0001C2.03125 9.61092 9.86375 1.97925 19.5 1.97925C29.1362 1.97925 36.9688 9.61092 36.9688 19.0001C36.9688 28.3892 29.1362 36.0209 19.5 36.0209ZM19.5 4.35425C11.2125 4.35425 4.46875 10.9251 4.46875 19.0001C4.46875 27.0751 11.2125 33.6459 19.5 33.6459C27.7875 33.6459 34.5312 27.0751 34.5312 19.0001C34.5312 10.9251 27.7875 4.35425 19.5 4.35425Z",
    fill: "#54ba4c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1923 24.6684C16.8673 24.6684 16.5586 24.5417 16.3311 24.32L11.7323 19.8392C11.2611 19.38 11.2611 18.62 11.7323 18.1609C12.2036 17.7017 12.9836 17.7017 13.4548 18.1609L17.1923 21.8025L25.5448 13.6642C26.0161 13.205 26.7961 13.205 27.2673 13.6642C27.7386 14.1234 27.7386 14.8834 27.2673 15.3425L18.0536 24.32C17.8261 24.5417 17.5173 24.6684 17.1923 24.6684Z",
    fill: "#E1E9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.da56173f4e9674bddea418db008dbcc8.svg";
export { ForwardRef as ReactComponent };